const baseStyle = {};
const defaultProps = {
    size: 'md',
    variant: 'light'
};
const parts = ['container', 'item', 'sidemenuTop', 'bottom'];
const sizes = {
    md: {
        item: {
            minH: '40px'
        }
    },
    lg: {
        item: {
            minH: '56px'
        }
    }
};
const variants = {
    light: {
        container: {
            bg: 'white'
        },
        bottom: {
            borderTop: '1px solid lightgray'
        },
        sidemenuTop: {
            borderBottom: '1px solid lightgray'
        },
        item: {}
    },
    dark: {
        container: {
            bg: 'darkBlue.main',
            color: 'white'
        },
        bottom: {
            borderTop: '1px solid black'
        },
        sidemenuTop: {
            borderBottom: '1px solid black'
        },
        item: {}
    }
};
export default {
    baseStyle,
    defaultProps,
    parts,
    sizes,
    variants
};
